import http from '../plugins/axios';

const getBookingIds = async (params = {}) => {
  const response = await http.get('/api/company/v3/booking/ids', { params });
  return response.data;
};

export {
  getBookingIds
};
